import { Component, Input } from '@angular/core';
import { DayOfWeek, TimeSpan } from '../hours-of-operation.interface';
import { UntypedFormControl } from '@angular/forms';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);

@Component({
  selector: 'forms-day-of-week-display',
  templateUrl: './day-of-week-display.component.html',
  styleUrls: ['./day-of-week-display.component.scss'],
})
export class DayOfWeekDisplayComponent {
  @Input() dayOfWeek: DayOfWeek;
  @Input() control: UntypedFormControl;

  // make this constant available to the template
  DayOfWeek = DayOfWeek;

  get hours(): TimeSpan[] {
    return this.control.value.filter((span: TimeSpan) => {
      if (span.dayOfWeek) {
        return span.dayOfWeek.indexOf(this.dayOfWeek) >= 0;
      }
      return false;
    });
  }

  displayTime(time: string): string {
    if (!time) {
      return '';
    }
    let parseFormat = 'H:m';
    // count instances of ':'
    if (time.split(':').length - 1 === 2) {
      parseFormat = 'H:m:s';
    }
    return dayjs(time, parseFormat).format('LT');
  }

  is24Hour(span: TimeSpan): boolean {
    if (span.opens === span.closes) {
      return true;
    }

    return (
      (span.opens === '0:00' || span.opens === '00:00') &&
      (span.closes === '0:00' || span.closes === '00:00' || span.closes === '24:00')
    );
  }

  hasTime(span: TimeSpan): boolean {
    return !!span.opens || !!span.closes;
  }

  dayDisplayNameKey(day: DayOfWeek): string {
    switch (day) {
      case DayOfWeek.SUNDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.SUNDAY';
      case DayOfWeek.MONDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.MONDAY';
      case DayOfWeek.TUESDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.TUESDAY';
      case DayOfWeek.WEDNESDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.WEDNESDAY';
      case DayOfWeek.THURSDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.THURSDAY';
      case DayOfWeek.FRIDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.FRIDAY';
      case DayOfWeek.SATURDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.SATURDAY';
    }
    return day;
  }
}
